import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchApprovedTemplates } from "../../../../core/data/redux/slices/ApprovedTemplatesSlice";
import { fetchWabaTemplates } from "../../../../core/data/redux/slices/WabaTemplateSlice";

/**
 * Invisible wrapper mounted on every WABA route.
 * Ensures both approved templates (used by campaigns) AND wabaTemplates
 * (used by the Send Template modal in the chat window) are loaded, so
 * every WABA page works without each component managing its own fetch.
 */
const WabaDataLoader = ({ children }) => {
  const dispatch = useDispatch();

  const { data: approvedData, loading: approvedLoading } =
    useSelector((state) => state.approvedTemplates);

  const { wabaTemplates, loading: wabaLoading } =
    useSelector((state) => state.wabaTemplate);

  useEffect(() => {
    if (!approvedData?.length && !approvedLoading) {
      dispatch(fetchApprovedTemplates());
    }
    if (!wabaTemplates?.length && !wabaLoading) {
      dispatch(fetchWabaTemplates({ page: 1, limit: 100, search: "" }));
    }
  }, [dispatch]); // run once on mount

  return children;
};

export default WabaDataLoader;
